import { TreeDndTree } from '@/components/tree-dnd/tree-dnd-node';
import { useTreeDndStore } from '@/components/tree-dnd/tree-dnd-store';

export function TreeDndPlayground() {
  const tree = useTreeDndStore((state) => state.tree);

  return (
    <div className="grid gap-8 lg:grid-cols-2">
      <section>
        <h2 className="mb-3 text-sm font-medium text-muted-foreground">
          Tree UI
        </h2>
        <TreeDndTree />
      </section>

      <section>
        <h2 className="mb-3 text-sm font-medium text-muted-foreground">Data</h2>
        <pre className="max-h-[32rem] overflow-auto rounded-lg border bg-muted/30 p-4 text-xs">
          {JSON.stringify(tree, null, 2)}
        </pre>
      </section>
    </div>
  );
}
